import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SectionService } from '../services/section.service';
import { map } from 'rxjs';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';

export const serviceStatusGuard: CanActivateFn = (route, state) => {
    const sectionService = inject(SectionService);
    const messageService = inject(MessageService);
    const router = inject(Router);

    const currentUrl = state.url;

    const isDevMode = !environment.production || environment.stage === 'local' || environment.stage === 'development';
    if (isDevMode) {
        return true;
    }

    return sectionService.getSections().pipe(
        map((sections) => {
            // Buscar coincidencia en secciones
            for (const section of sections) {

                // Caso sección directa
                if (section.route === currentUrl) {
                    if (section.status !== 'enabled') {
                        return router.createUrlTree(['/']);
                    }
                    return true;
                }

                // Caso subsección
                if (section.subSections) {
                    for (const sub of section.subSections) {
                        if (sub.route === currentUrl) {
                            if (sub.status !== 'enabled' || section.status !== 'enabled') {
                                messageService.add({
                                    severity: 'warn',
                                    summary: 'Servicio no disponible',
                                    detail: 'Este servicio no está habilitado actualmente.',
                                    life: 4000
                                });

                                return router.createUrlTree(['/']);
                            }
                            return true;
                        }
                    }
                }
            }

            // Si no encuentra la ruta, permitir (o bloquear según tu criterio)
            return true;
        })
    );
};
